(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yic-faq"] && !Shopify.designMode) return;
  try {
    
if(!window.yicFaqEditorListener){
  window.yicFaqEditorListener=true;
  document.addEventListener('shopify:block:select',event=>{
    const item=event.target.closest('.yq__item');
    if(item)item.open=true;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yic-flipbook"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yic-flipbook')) {
  customElements.define('yic-flipbook', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.pages = [...this.querySelectorAll('[data-page]')];
      this.reader = this.querySelector('.yf__reader');
      this.book = this.querySelector('.yf__book');
      this.dialog = this.querySelector('dialog');
      this.index = 0;
      if (!this.pages.length) { this.hidden = true; return; }
      this.hidden = false;
      this.mobile = matchMedia('(max-width:749px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1), {signal});
      this.querySelector('[data-expand]').addEventListener('click', () => {
        this.dialog.append(this.reader);
        this.dialog.showModal();
        this.render();
        this.querySelector('[data-close]').focus();
      }, {signal});
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('close', () => {
        this.querySelector('.yf__home').append(this.reader);
        this.index = this.normalize(this.index);
        this.render();
        this.querySelector('[data-expand]').focus();
      }, {signal});
      this.reader.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault(); this.move(e.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.book.addEventListener('touchstart', e => {
        this.touch = e.touches.length === 1 ? {x:e.touches[0].clientX,y:e.touches[0].clientY} : null;
      }, {signal,passive:true});
      this.book.addEventListener('touchend', e => {
        if (!this.touch || !e.changedTouches.length) return;
        const dx=e.changedTouches[0].clientX-this.touch.x,dy=e.changedTouches[0].clientY-this.touch.y;
        if(Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.5) this.move(dx<0?1:-1);
        this.touch=null;
      }, {signal,passive:true});
      this.book.addEventListener('touchcancel', () => {this.touch=null;}, {signal});
      this.mobile.addEventListener('change', () => {
        this.index=this.normalize(this.index); this.render();
      }, {signal});
      document.addEventListener('shopify:block:select', e => {
        const i=this.pages.findIndex(p=>p.dataset.blockId===e.detail.blockId);
        if(i>=0){this.index=this.normalize(i);this.render();}
      }, {signal});
      this.classList.add('is-ready');
      this.render();
    }
    get step(){return this.mobile.matches || this.index === 0 ? 1 : 2;}
    normalize(i){return this.mobile.matches || i === 0 ? i : 1 + Math.floor((i-1)/2)*2;}
    move(direction){
      const next=direction>0 ? this.index+this.step : (this.mobile.matches ? this.index-1 : (this.index===1 ? 0 : this.index-2));
      if(next<0 || next>=this.pages.length) return;
      this.index=next;this.render(direction);
      if(this.dialog.open)this.dialog.scrollTop=0;
    }
    render(direction=0){
      const end=Math.min(this.index+this.step,this.pages.length);
      const singlePage=end-this.index===1;
      this.book.classList.toggle('yf__book--single', singlePage);
      this.book.classList.toggle('yf__book--cover', this.index===0);
      this.pages.forEach((page,i)=>{
        const visible=i>=this.index&&i<end;
        page.hidden=!visible;
        page.dataset.side=singlePage?'':(i===this.index?'left':'right');
        if(visible){
          const img=page.querySelector('img');if(img)img.loading='eager';
          page.getAnimations().forEach(a=>a.cancel());
          if(direction && !this.reduced.matches)page.animate([
            {transform:`rotateY(${direction*18}deg)`,opacity:.6},
            {transform:'rotateY(0deg)',opacity:1}
          ],{duration:380,easing:'ease-out'});
        }
      });
      this.querySelector('[data-prev]').disabled=this.index===0;
      this.querySelector('[data-next]').disabled=end===this.pages.length;
      const range=this.index+1===end?String(end):`${this.index+1}–${end}`;
      this.querySelector('[data-status]').textContent=this.dataset.countLabel.replace('[range]',range).replace('[total]',String(this.pages.length));
    }
    disconnectedCallback(){
      this.controller?.abort();this.controller=null;
      if(this.dialog?.open)this.dialog.close();
      if(this.reader)this.querySelector('.yf__home').append(this.reader);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yic-header"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('yic-navigation')){
  customElements.define('yic-navigation',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      const signal=this.controller.signal;
      const details=this.querySelector('details');
      this.addEventListener('keydown',event=>{
        if(event.key==='Escape'&&details.open){details.open=false;details.querySelector('summary').focus();}
      },{signal});
      this.querySelector('.yn__panel').addEventListener('click',event=>{
        if(event.target.closest('a'))details.open=false;
      },{signal});
      document.addEventListener('click',event=>{if(!this.contains(event.target))details.open=false;},{signal});
      matchMedia('(min-width:990px)').addEventListener('change',event=>{if(event.matches)details.open=false;},{signal});
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yic-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yic-animated-hero')) {
  customElements.define('yic-animated-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.brush !== 'true' || this.played || !this.querySelector('.yic-hero__heading em')) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.classList.add('yic-brush-pending');
      this.brushObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.classList.remove('yic-brush-pending');
          this.classList.add('yic-brush-drawn');
          this.played = true;
          this.brushObserver.disconnect();
        }
      }, { threshold: .35 });
      this.brushObserver.observe(this.querySelector('.yic-hero__heading em'));
    }
    disconnectedCallback() {
      this.brushObserver?.disconnect();
      this.classList.remove('yic-brush-pending');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yic-look-inside"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yic-page-gallery')) {
    customElements.define('yic-page-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.yiciController) this.yiciController.abort();
        this.yiciController = new AbortController();
        this.paintObserver?.disconnect();
        const paintings = [...this.querySelectorAll('.yic-paint--active')];
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
          this.paintObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              entry.target.classList.remove('is-pending');
              entry.target.classList.add('is-painted');
              this.paintObserver.unobserve(entry.target);
            });
          }, { threshold: .2 });
          paintings.forEach(painting => {
            if (painting.classList.contains('is-painted')) return;
            painting.classList.add('is-pending');
            this.paintObserver.observe(painting);
          });
        }
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-yici-open]');
          const dialog = this.querySelector('dialog');
          if (!link || !dialog || typeof dialog.showModal !== 'function') return;
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          this.yiciTrigger = link;
          const image = document.createElement('img');
          image.src = link.href;
          image.alt = link.dataset.yiciAlt || '';
          const thumbnail = link.querySelector('img');
          if (thumbnail) {
            image.width = thumbnail.naturalWidth || thumbnail.width;
            image.height = thumbnail.naturalHeight || thumbnail.height;
          }
          const paintedPage = link.querySelector('.yic-paint--active');
          if (paintedPage) {
            const copy = paintedPage.cloneNode(true);
            copy.classList.remove('is-pending', 'is-painted');
            copy.querySelector('img').replaceWith(image);
            this.querySelector('.yic-inside__full-page').replaceChildren(copy);
          } else {
            this.querySelector('.yic-inside__full-page').replaceChildren(image);
          }
          this.querySelector('.yic-inside__dialog-title').textContent = link.dataset.yiciTitle || '';
          dialog.showModal();
        }, { signal: this.yiciController.signal });
        const dialog = this.querySelector('dialog');
        if (dialog) {
          dialog.addEventListener('click', (event) => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }, { signal: this.yiciController.signal });
          dialog.addEventListener('close', () => {
            if (this.yiciTrigger && this.yiciTrigger.isConnected) this.yiciTrigger.focus();
          }, { signal: this.yiciController.signal });
        }
      }
      disconnectedCallback() {
        this.paintObserver?.disconnect();
        this.querySelectorAll('.is-pending').forEach(el => el.classList.remove('is-pending'));
        if (this.yiciController) this.yiciController.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yic-photo-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yic-photo-hero')) {
  customElements.define('yic-photo-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.brush !== 'true' || this.played || !this.querySelector('.yic-photo-hero__heading em')) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.classList.add('yic-brush-pending');
      this.brushObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.classList.remove('yic-brush-pending');
          this.classList.add('yic-brush-drawn');
          this.played = true;
          this.brushObserver.disconnect();
        }
      }, { threshold: .35 });
      this.brushObserver.observe(this.querySelector('.yic-photo-hero__heading em'));
    }
    disconnectedCallback() {
      this.brushObserver?.disconnect();
      this.classList.remove('yic-brush-pending');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yic-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yic-product-page')) {
    customElements.define('yic-product-page', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.setAttribute('data-ready', '');
        const select = this.querySelector('[data-yp-variant]');
        const quantity = this.querySelector('[data-yp-quantity]');
        const minus = this.querySelector('[data-yp-minus]');
        const plus = this.querySelector('[data-yp-plus]');
        const syncQuantityButtons = () => {
          if (!quantity) return;
          minus.disabled = Number(quantity.value) <= Number(quantity.min || 1);
          plus.disabled = quantity.max !== '' && Number(quantity.value) + Number(quantity.step || 1) > Number(quantity.max);
        };
        const selectImage = (id) => {
          if (!id) return;
          const panels = [...this.querySelectorAll('[data-yp-panel]')];
          if (!panels.some(panel => panel.dataset.ypPanel === id)) return;
          panels.forEach(panel => { panel.hidden = panel.dataset.ypPanel !== id; });
          this.querySelectorAll('[data-yp-thumb]').forEach(thumb => {
            if (thumb.dataset.ypThumb === id) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
        };
        const updateVariant = (changeImage = false, updateUrl = false) => {
          if (!select) return;
          const option = select.selectedOptions[0];
          if (!option) return;
          const data = option.dataset;
          this.querySelector('[data-yp-price]').textContent = data.price;
          this.querySelector('[data-yp-compare]').hidden = !data.compare;
          this.querySelector('[data-yp-compare-value]').textContent = data.compare || '';
          const submit = this.querySelector('[data-yp-submit]');
          submit.disabled = data.available !== 'true';
          submit.textContent = submit.disabled ? this.dataset.soldLabel : this.dataset.addLabel;
          const express = this.querySelector('[data-yp-express]');
          if (express) express.hidden = submit.disabled;
          quantity.min = data.min || '1';
          quantity.step = data.step || '1';
          if (data.max) quantity.max = data.max;
          else quantity.removeAttribute('max');
          quantity.value = quantity.min;
          syncQuantityButtons();
          if (changeImage) selectImage(data.image);
          if (updateUrl) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', option.value);
            window.history.replaceState(window.history.state, '', url);
          }
        };
        if (select) {
          select.addEventListener('change', () => updateVariant(true, true), { signal });
          updateVariant();
          window.addEventListener('popstate', () => {
            const value = new URL(window.location.href).searchParams.get('variant');
            if ([...select.options].some(option => option.value === value)) {
              select.value = value;
              updateVariant(true);
            }
          }, { signal });
        }
        if (quantity) {
          minus.hidden = false;
          plus.hidden = false;
          quantity.addEventListener('input', syncQuantityButtons, { signal });
          quantity.addEventListener('change', syncQuantityButtons, { signal });
        }
        const dialog = this.querySelector('.yp-dialog');
        this.addEventListener('click', (event) => {
          const thumb = event.target.closest('[data-yp-thumb]');
          const zoom = event.target.closest('[data-yp-zoom]');
          if (thumb || zoom) {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            if (thumb) {
              event.preventDefault();
              selectImage(thumb.dataset.ypThumb);
            } else if (dialog && typeof dialog.showModal === 'function') {
              event.preventDefault();
              this.zoomTrigger = zoom;
              const image = document.createElement('img');
              image.src = zoom.href;
              image.alt = zoom.dataset.ypAlt || '';
              this.querySelector('.yp-full-image').replaceChildren(image);
              dialog.showModal();
            }
          }
          if (quantity && event.target.closest('[data-yp-minus]')) {
            quantity.stepDown();
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (quantity && event.target.closest('[data-yp-plus]')) {
            quantity.stepUp();
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, { signal });
        if (dialog) {
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }, { signal });
          dialog.addEventListener('close', () => {
            if (this.zoomTrigger && this.zoomTrigger.isConnected) this.zoomTrigger.focus();
          }, { signal });
        }
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const details = event.target.closest('details');
          if (details) details.open = true;
        }, { signal });
      }
      disconnectedCallback() {
        if (this.controller) this.controller.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yic-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yic-shop-product')) {
    customElements.define('yic-shop-product', class extends HTMLElement {
      connectedCallback() {
        if (this.yicsController) this.yicsController.abort();
        this.yicsController = new AbortController();
        const select = this.querySelector('[data-yics-variant]');
        if (!select) return;
        const update = (changeImage = false) => {
          const option = select.selectedOptions[0];
          if (!option) return;
          const data = option.dataset;
          this.querySelector('[data-yics-price]').textContent = data.price;
          const compare = this.querySelector('[data-yics-compare]');
          compare.hidden = !data.compare;
          this.querySelector('[data-yics-compare-value]').textContent = data.compare || '';
          const button = this.querySelector('[data-yics-submit]');
          button.disabled = data.available !== 'true';
          button.textContent = button.disabled ? this.dataset.soldLabel : this.dataset.addLabel;
          const quantity = this.querySelector('[data-yics-quantity]');
          quantity.min = data.min || '1';
          quantity.step = data.step || '1';
          if (data.max) quantity.max = data.max;
          else quantity.removeAttribute('max');
          quantity.value = quantity.min;
          const image = this.querySelector('.yic-shop__image');
          if (changeImage && image && data.image && this.dataset.imageOverride !== 'true') {
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.src = data.image;
            image.alt = data.imageAlt || '';
            image.width = Number(data.width);
            image.height = Number(data.height);
          }
        };
        select.addEventListener('change', () => update(true), { signal: this.yicsController.signal });
        update();
      }
      disconnectedCallback() {
        if (this.yicsController) this.yicsController.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
